module.exports = "<div id=\"template-dialog-confirm\">\n    <p>{{templateUser}}</p>\n</div>";